export default class CRTShader extends Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline {
    private _time: any;
    private _intensity: any;

    constructor(game){
        super({
            game: game,
            renderer: game.renderer,
            fragShader:
            `
            precision mediump float;

            uniform vec2 resolution;
            uniform sampler2D sampler;
            uniform float time;
            uniform float intensity;

            vec2 crtCurve(vec2 uv,float r) 
            {
                uv = (uv - 0.5) * 2.0;// uv is now -1 to 1
                uv = r*uv/sqrt(r*r -dot(uv, uv));
                uv = (uv / 2.0) + 0.5;// back to 0-1 coords
                return uv;
            }
            
            vec3 scanline(vec2 coord, vec3 screen, float multip)
            {
                screen.rgb -= sin((coord.y + (time * .007))) * multip;
                return screen;
            }
            
            vec3 sampleSplit(sampler2D tex, vec2 coord)
            {
                vec3 frag;
                frag.r = texture2D(tex, vec2(coord.x - 0.005 * sin(time) * intensity, coord.y)).r;
                frag.g = texture2D(tex, vec2(coord.x, coord.y)).g;
                frag.b = texture2D(tex, vec2(coord.x + 0.005 * sin(time) * intensity, coord.y)).b;
                return frag;
            }

            void main(void)
            {
                vec2 uv = gl_FragCoord.xy / resolution.xy;
                uv.y = 1.0 - uv.y;
                gl_FragColor = texture2D(sampler,uv);
                float curve = 7.5 - (sin(time) * intensity );
                uv = crtCurve(uv,curve);

                gl_FragColor.rgb = sampleSplit(sampler, uv);

                vec2 screenSpace = uv * resolution.xy;
                gl_FragColor.rgb = scanline(screenSpace, gl_FragColor.rgb, 0.03);
                gl_FragColor.rgb = scanline(screenSpace * 0.5, gl_FragColor.rgb, 0.01);

            }

            `
            
        });

    } 

    set time(t){
        this._time = t;
        this.setFloat1('time',this._time);
    }

    get time(){
        return this._time;
    }

    set intensity(t){
        this._intensity = t;
        
        this.setFloat1('intensity',this._intensity);
    }

    get intensity(){
        return this._time;
    }



}